module.exports = __webpack_public_path__ + "img/balloon1.76500ac4.png";